import { JOURNEY_STAGES } from "../data/journeyStages";
import { useJourneyStore } from "../game/state/journeyMachine";

export function StageNav() {
  const stageIndex = useJourneyStore((s) => s.stageIndex);
  const guided = useJourneyStore((s) => s.guided);
  const paused = useJourneyStore((s) => s.paused);
  const { nextStage, prevStage, goToStage, toggleGuided, startGuided, togglePause } = useJourneyStore();

  return (
    <nav aria-label="Navegación del recorrido" className="flex flex-col gap-3">
      <ol className="flex flex-wrap gap-1.5" aria-label="Etapas">
        {JOURNEY_STAGES.map((stage, i) => (
          <li key={stage.id}>
            <button
              type="button"
              onClick={() => goToStage(i)}
              aria-current={i === stageIndex ? "step" : undefined}
              aria-label={`Etapa ${i + 1}: ${stage.title}`}
              className={`h-8 min-w-8 rounded-md border px-2 text-xs font-medium ${
                i === stageIndex
                  ? "border-[var(--cale-accent)] bg-[var(--cale-accent)] text-white"
                  : "border-[var(--cale-border)] bg-[var(--cale-surface-raised)] hover:bg-[var(--cale-surface)]"
              }`}
            >
              {i + 1}
            </button>
          </li>
        ))}
      </ol>
      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={prevStage}
          disabled={stageIndex === 0}
          className="rounded-md border border-[var(--cale-border)] px-3 py-1.5 text-sm disabled:opacity-40"
        >
          Anterior
        </button>
        <button
          type="button"
          onClick={nextStage}
          disabled={stageIndex === JOURNEY_STAGES.length - 1}
          className="rounded-md bg-[var(--cale-accent)] px-3 py-1.5 text-sm text-white hover:bg-[var(--cale-accent-strong)] disabled:opacity-40"
        >
          Siguiente
        </button>
        <button
          type="button"
          onClick={guided ? toggleGuided : startGuided}
          aria-pressed={guided}
          className={`rounded-md px-3 py-1.5 text-sm ${
            guided
              ? "border border-[var(--cale-border)]"
              : "bg-[var(--cale-accent)] text-white hover:bg-[var(--cale-accent-strong)]"
          }`}
        >
          {guided ? "Detener guiado" : "▶ Recorrido guiado"}
        </button>
        <button
          type="button"
          onClick={togglePause}
          aria-pressed={paused}
          className="rounded-md border border-[var(--cale-border)] px-3 py-1.5 text-sm"
        >
          {paused ? "Reanudar" : "Pausa"}
        </button>
      </div>
    </nav>
  );
}
